"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickArticleFor = exports.pickByLeadingVowel = exports.sanitizeToVisibleAscii = void 0;
/**
 * Sanitizes string input to only visible ASCII characters and common whitespace.
 *
 * This function removes any character that is not a printable ASCII character (0x20-0x7E)
 * or extended ASCII character (0x80-0xFF), except for tab (0x09), line feed (0x0A),
 * and carriage return (0x0D), which are kept as they are commonly used whitespace.
 *
 * @param input - The string to sanitize, or null/undefined.
 * @returns The sanitized string, or the original null/undefined if input is null/undefined.
 */
function sanitizeToVisibleAscii(input) {
    if (input === null || input === undefined) {
        return input;
    }
    // Keep only tab (0x09), LF (0x0A), CR (0x0D), printable ASCII (0x20-0x7E),
    // and extended ASCII (0x80-0xFF).
    // eslint-disable-next-line no-control-regex
    return input.replace(/[^\x09\x0A\x0D\x20-\x7E\x80-\xFF]/g, "");
}
exports.sanitizeToVisibleAscii = sanitizeToVisibleAscii;
/**
 * Chooses between two caller-supplied values based on whether a word starts with a vowel
 * (a/e/i/o/u, case-insensitive) -- handy for picking the right English article ("a" vs "an")
 * to precede a dynamic word like an organization name.
 *
 * @param word - The word whose first letter determines which value is returned.
 * @param consonantCase - The value to return when `word` does not start with a vowel.
 * @param vowelCase - The value to return when `word` starts with a vowel.
 * @returns `vowelCase` or `consonantCase` depending on `word`'s first letter, or `undefined`
 *          if `word` is undefined or empty.
 */
function pickByLeadingVowel(word, consonantCase, vowelCase) {
    if (!word) {
        return consonantCase;
    }
    return /^[aeiou]/i.test(word) ? vowelCase : consonantCase;
}
exports.pickByLeadingVowel = pickByLeadingVowel;
/**
 * Picks the correct English indefinite article ("a" or "an") for a word, based on whether it
 * starts with a vowel. A convenience wrapper over pickByLeadingVowel for that common case.
 *
 * @param word - The word the article precedes.
 * @returns "a" or "an" depending on `word`'s first letter, or `undefined` if `word` is
 *          undefined or empty.
 */
function pickArticleFor(word) {
    return pickByLeadingVowel(word, "a", "an");
}
exports.pickArticleFor = pickArticleFor;
